import React, { Component } from "react";
import { connect } from "react-redux";
import {
  addDsAction,
  delDsAction,
  changeDsAction,
  changeSelRowAction,
  isDelAction,
} from "../../redux/pl/actions";

const mapStateToProps = (state) => {
  return {
    ds: state.plReducer.ds,
    selRow: state.plReducer.selRow,
    isDel: state.plReducer.isDel,
  };
};

class Main extends Component {
  constructor(props) {
    super(props);
    this.addPos = this.addPos.bind(this);
    this.delPos = this.delPos.bind(this);
    this.changeField = this.changeField.bind(this);
    this.checkZVal = this.checkZVal.bind(this);
    this.changeRow = this.changeRow.bind(this);

    this.tbRef = React.createRef();

    this.props.dispatch(changeSelRowAction(null));
  }

  componentDidUpdate(prevProps) {
    /*
     * 削除時データセットIDを修正
     * @since hara 2021-02-05
     */
    if (prevProps.ds !== this.props.ds && this.props.isDel) {
      /*
       * 地質ID修正
       */
      const ds = [...this.props.ds];
      ds.forEach((el, index) => {
        el.ID = index + 1;
      });
      this.props.dispatch(changeDsAction(ds));

      /*
       * 選択行移動
       */
      const trs = this.tbRef.childNodes;
      const rowNum = trs.length;
      const selRow = parseInt(this.props.selRow);
      let newSelRow = null;

      if (selRow === rowNum) {
        //最終行削除の場合
        if (selRow !== 0) {
          //複数行の場合前の行を選択
          trs[rowNum - 1].click();
          newSelRow = rowNum - 1;
        }
        this.props.dispatch(changeSelRowAction(newSelRow));
      }

      this.props.dispatch(isDelAction(false));
    }
  }

  /*
   * 平面位置追加
   * @since hara 2021-02-05
   */
  addPos() {
    if (this.props.ds.length >= 3) {
      alert("平面予測位置は3つまで作成できます。");
    } else {
      this.props.dispatch(addDsAction(this.props.ds.length + 1));
    }
  }

  /*
   * 平面位置削除
   * @since hara 2021-02-05
   */
  delPos() {
    if (this.props.selRow !== null) {
      this.props.dispatch(delDsAction(this.props.selRow));
      this.props.dispatch(isDelAction(true));
    }
  }

  /*
   * フィールド変更
   * @param {Number} index フィールドの行インデックス
   * @param {String} key フィールドの列インデックス
   * @param {Event} e イベント情報
   * @since hara 2021-02-05
   */
  changeField(index, key, e) {
    const ds = [...this.props.ds];
    ds[index] = { ...ds[index], [key]: e.target.value, estFlg: 0 };
    this.props.dispatch(changeDsAction(ds));
  }

  /*
   * Z値チェック
   * @param {Number} index フィールドの行インデックス
   * @param {Event} e イベント情報
   * @since hara 2021-04-19
   */
  checkZVal(index, e) {
    let value = e.target.value;
    if (isNaN(value) || value < 0) {
      const ds = [...this.props.ds];
      ds[index] = { ...ds[index], ZVal: 0 };
      this.props.dispatch(changeDsAction(ds));
    }
  }

  /*
   * テーブル選択
   * @param {Event} e イベント情報
   * @since hara 2021-02-05
   */
  changeRow(e) {
    e.target.closest("tbody").childNodes.forEach((el) => {
      el.classList.remove("selRow");
    });
    const tr = e.target.closest("tr");
    tr.classList.add("selRow");

    this.props.dispatch(changeSelRowAction(parseInt(tr.id)));
  }

  render() {
    return (
      <div>
        <div className="l-flex">
          <button className="sBtn" onClick={this.addPos}>
            追加
          </button>
          <button className="sBtn l-mlS" onClick={this.delPos}>
            削除
          </button>
        </div>

        <div className="TWrap l-mtS" style={{ overflowY: "scroll" }}>
          <table className="table">
            <thead>
              <tr>
                <th className="tsS">ID</th>
                <th>Z属性</th>
                <th>Z値</th>
              </tr>
            </thead>
            <tbody ref={(ref) => (this.tbRef = ref)}>
              {this.props.ds !== undefined &&
                this.props.ds.map((el, index) => (
                  <tr id={index} key={index} onClick={this.changeRow}>
                    <td>
                      <p>{el.ID}</p>
                    </td>
                    <td>
                      {/*★ここから公開版で削除*/}
                      {/*<select className='selectT' type='text' value={el.ZAttr} onChange={e => this.changeField(index, 'ZAttr', e)}>
                                                <option value='dep'>深度</option>
                                                <option value='elv'>標高</option>
                                            </select>*/}
                      {/*★ここまで公開版で削除 下のコメント解除*/}
                      <p>深度</p>
                    </td>
                    <td>
                      <input
                        className="textT"
                        type="text"
                        value={el.ZVal}
                        onBlur={(e) => this.checkZVal(index, e)}
                        onChange={(e) => this.changeField(index, "ZVal", e)}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(Main);
